/**
 * @type {import("vue-router").RouteConfig[]}
 */
//  routeName: '暂无项目', // 自身的名字
//  prouteName: '暂无项目',// 用来判断第二级高亮
//  pname //用来判断第一级导航高亮
import workbench from "./workbench";
import project from "./project";
import knowledge from "./knowledge";
import message from "./message";
import application from "./application";
import system from "./system";
import userCenter from "./userCenter";
import admin from "@/CommonDP/router/modules/admin";

export const dynamic = [
  {
    path: "/catalogInit",
    name: "catalogInit",
    component: () => import("@/CommonDP/pages/mainMg/catalogInit"),
    meta: {
      routeName: "未设置关键目录"
    }
  },
  {
    path: "/examine-approve",
    name: "examineApprove",
    component: () => import("@/CommonDP/pages/mainMg/approval/index.vue"),
    meta: {
      routeName: "审批",
      pname: "审批",
      hideSubMenu: true,
      icon: require('@/CommonDP/assets/settings/examineApprove.svg')
    }
  },
  {
    path: "/meta-data",
    name: "meta-data",
    component: () => import("@/CommonDP/pages/mainMg/lowcode/metadata/index.vue"),
    meta: {
      routeName: "低代码",
      pname: "低代码",
      hideSubMenu: true,
      icon: require("@/CommonDP/assets/settings/metaData.svg")
    }
  },
  ...workbench,
  ...project,
  ...knowledge,
  ...message,
  ...application,
  ...system,
  ...userCenter,
  ...admin
];
const newRoutes = [];
const flatData = routes => {
  routes.forEach(el => {
    newRoutes.push(el);
    el.children && el.children.length > 0 ? flatData(el.children) : "";
  });
};
flatData(dynamic);
export default newRoutes;
